import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext } from 'react';
export const BlockContext = createContext({});
export const useBlockContext = () => useContext(BlockContext);
export function withBlockContext(Component) {
    return (props) => {
        return (_jsx(BlockContext.Provider, Object.assign({ value: { builderBlock: props.builderBlock } }, { children: _jsx(Component, Object.assign({}, props)) })));
    };
}
//# sourceMappingURL=BlockContext.js.map